var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncement02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14L5.57465 20.2985C5.61893 20.4757 5.64107 20.5643 5.66727 20.6416C5.92317 21.3971 6.60352 21.9283 7.39852 21.9933C7.4799 22 7.5712 22 7.75379 22C7.98244 22 8.09677 22 8.19308 21.9906C9.145 21.8983 9.89834 21.145 9.99066 20.193C10 20.0967 10 19.9824 10 19.7538V5.49997M18.5 13.5C20.433 13.5 22 11.933 22 9.99997C22 8.06698 20.433 6.49997 18.5 6.49997M10.25 5.49997H6.5C4.01472 5.49997 2 7.51469 2 9.99998C2 12.4853 4.01472 14.5 6.5 14.5H10.25C12.0164 14.5 14.1772 15.4469 15.8443 16.3556C16.8168 16.8858 17.3031 17.1508 17.6216 17.1118C17.9169 17.0757 18.1402 16.9431 18.3133 16.7011C18.5 16.4401 18.5 15.918 18.5 14.8737V5.12626C18.5 4.08197 18.5 3.55982 18.3133 3.29886C18.1402 3.05687 17.9169 2.92427 17.6216 2.8881C17.3031 2.84909 16.8168 3.11417 15.8443 3.64433C14.1772 4.55309 12.0164 5.49997 10.25 5.49997Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement02);
export default __webpack_public_path__ + "static/media/announcement-02.c525e95ae833c3b664564ea52108052d.svg";
export { ForwardRef as ReactComponent };